module.exports = __webpack_public_path__ + "static/media/drumstick-bite.f0666d85.svg";